import React from 'react'
import { useLocation } from 'react-router-dom'

import BusinessDetailsForm from '../../components/business/form'
import LocaleForm from '../../components/profile/LocaleForm'
import { useAlerts } from '../../context/alerts'
import useQuery from '../../context/useQuery'
import RemindersForm from '../../components/reminders/form'
import PageSectionTitle from '../../components/ui/pageSectionTitle'
import { AUTOMATIC_OVERDUE_FOLLOW_UPS_SECTION_ID } from '../../lib/profileSectionIds'

const UserProfile = () => {
  const query = useQuery()
  const location = useLocation()
  const { addAlert } = useAlerts()

  React.useEffect(() => {
    if(query.get('warning')) {
      addAlert({ type: 'warning', message: query.get('warning') })
    }
  }, [addAlert, query])

  React.useEffect(() => {
    if (location.hash !== `#${AUTOMATIC_OVERDUE_FOLLOW_UPS_SECTION_ID}`) {
      return
    }
    const el = document.getElementById(AUTOMATIC_OVERDUE_FOLLOW_UPS_SECTION_ID)
    if (!el) {
      return
    }
    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }, [location.hash])

  return (
    <div className='container-with-bg'>
      <div className='row'>
        <div className='card d-block'>
          <div className='card-body'>
            <BusinessDetailsForm
              autofocusField={query.get('autofocus') || ''}
              redirectAfterSaveTo={query.get('redirectAfterSaveTo') || undefined}
            />
          </div>
        </div>
      </div>
      <div className='row mt-4'>
        <div className='card d-block'>
          <div className='card-body'>
            <LocaleForm />
          </div>
        </div>
      </div>
      <div id={AUTOMATIC_OVERDUE_FOLLOW_UPS_SECTION_ID} className='row mt-4 scroll-mt-3'>
        <div className='card d-block'>
          <div className='card-body'>
            <PageSectionTitle title='Automatic Overdue Follow-Ups' description='Send automatic email follow-ups to your clients'/>
            <div className='my-4'/>
            <RemindersForm />
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserProfile
